import React, { useReducer, useEffect, useCallback } from 'react'

import { enterpriseInitiativeLoaderInitialState } from './store/State'

import enterpriseInitiativeLoaderReducer from './store/Reducer'

import EnterpriseInitiativeLoaderService from './Service'

import { IEnterpriseInitiativeLoaderProviderProps } from './Interfaces'
import { useSnackbar } from 'notistack'

const enterpriseInitiativeLoaderContext = {
  state: enterpriseInitiativeLoaderInitialState,
  handlers: {}
}

export type EnterpriseInitiativeLoaderContext = typeof enterpriseInitiativeLoaderContext

export const EnterpriseInitiativeLoaderContextProvider = React.createContext<EnterpriseInitiativeLoaderContext>(
  enterpriseInitiativeLoaderContext
)

const Provider: React.FC<IEnterpriseInitiativeLoaderProviderProps> = ({
  enterpriseId,
  submissionLinkCode,
  children
}) => {
  const [state, dispatch] = useReducer(enterpriseInitiativeLoaderReducer, enterpriseInitiativeLoaderInitialState)
  const { enqueueSnackbar } = useSnackbar()

  const onError = useCallback(
    error => {
      enqueueSnackbar(error, {
        variant: 'warning',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      })
    },
    [enqueueSnackbar]
  )

  const handlers = {}

  const contextValue = {
    ...enterpriseInitiativeLoaderContext,
    state,
    handlers
  }

  useEffect(() => {
    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search)

      const email = urlParams.get('e')

      if (enterpriseId && submissionLinkCode && email) {
        EnterpriseInitiativeLoaderService.loadEnterpriseInitiativeInfo(
          dispatch,
          enterpriseId,
          submissionLinkCode,
          email,
          onError
        )
      }
    }
  }, [submissionLinkCode, enterpriseId, onError])

  return (
    <EnterpriseInitiativeLoaderContextProvider.Provider value={contextValue}>
      {children}
    </EnterpriseInitiativeLoaderContextProvider.Provider>
  )
}

export default React.memo(Provider)
